<template>
  <VLoader v-if="_fetchingStatus === requestStatus.PENDING" />
  <div v-else class="postback-wrap">
    <VOverlay v-if="_updatingStatus === requestStatus.PENDING">
      <VLoader/>
    </VOverlay>
    <div class="postback-box mb-3">
      <div class="text-semibold mb-3">Global postback URL</div>

      <label class="postback-box-field mb-4">
        <div class="mb-1">URL</div>
        <textarea
            class="postback-box-field__area"
            v-model="url"
            ref="textFieldUrl"
        ></textarea>
      </label>

      <div class="d-flex justify-content-end">
        <VButton
            type="orange-outline"
            class="postback-box__btn"
            @click="onUpdatePostback"
        >
          Update
        </VButton>
      </div>
    </div>
    <div class="postback-box">
      <div class="postback-box-list">
        <div
            v-for="sub in postbackParams"
            :key="sub.value"
            class="postback-box-list__sub"
            @click="onInsertPostback(sub)"
        >
          <div>{{ sub.slug }}</div>
          <div>{{ sub.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestStatus, toasted } from '@/js/utils/constants';

export default {
  name: "Postback",
  data: () => ({
    requestStatus,
    postbackParams: [
      {
        slug: '{sub1}',
        value: 'sub1',
        label: 'campaign id'
      },
      {
        slug: '{sub2}',
        value: 'sub2',
        label: 'pixel id'
      },
      {
        slug: '{sub3}',
        value: 'sub3',
        label: 'click id'
      },
      {
        slug: '{sub4}',
        value: 'sub4',
        label: 'name surname'
      },
      {
        slug: '{sub5}',
        value: 'sub5',
        label: 'email'
      }
    ],
    url: '',
  }),
  computed: {
    _fetchingStatus() {
      return this.$store.state.postback.fetchingStatus;
    },
    _postbackData() {
      return this.$store.state.postback.data;
    },
    _updatingStatus() {
      return this.$store.state.postback.updatingStatus;
    },
  },
  mounted() {
    this.getPostback();
  },
  methods: {
    async getPostback() {
      await this.$store.dispatch('postback/getPostback');
      this.url = this._postbackData.postback_url;
    },
    onInsertPostback(sub) {
      const elRef = this.$refs.textFieldUrl;
      const { selectionStart, selectionEnd } = elRef;
      const link = this.url.substring(0, selectionStart) + sub.slug + this.url.substring(selectionEnd);

      elRef.value = link;
      elRef.focus();
      elRef.selectionEnd = (selectionStart === selectionEnd) ? (selectionStart + sub.slug.length) : selectionEnd;

      this.url = link;
    },
    async onUpdatePostback() {
      const { pixel_status, network_pixel_id } = this._postbackData;

      const formData = {
        pixel_status,
        postback_url: this.url
      };

      if (network_pixel_id > 0) formData.network_pixel_id = network_pixel_id;

      try {
        await this.$store.dispatch('postback/updatePostback', formData);
        this.$toasted.success(toasted.text.success);
      } catch (err) {
        this.$toasted.error(toasted.text.error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.postback {
  &-wrap {
    position: relative;
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
  }

  &-box {
    background-color: #ffffff;
    box-shadow: 0 3px 10px 3px rgba(43, 72, 105, 0.11);
    border-radius: 8px;
    padding: 24px;

    &-field {
      display: flex;
      flex-direction: column;
      width: 100%;
      position: relative;

      &__area {
        width: 100%;
        min-height: 40px;
        border: 1px solid var(--grey-light-1);
        border-radius: 8px;
        padding: 8px 16px;
        position: relative;
        font-family: var(--OpenSans);
        resize: none;

        &:focus {
          outline: none;
          border: 1px solid var(--blue-main);
        }
      }
    }

    &__btn {
      max-width: 170px;
    }

    &-list {
      &__sub {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--grey-main);
        border-bottom: 1px solid var(--grey-light-1);
        padding: 12px 8px;
        transition: .15s linear;
        cursor: pointer;

        &:hover {
          background-color: var(--blue-light);
        }
      }
    }
  }
}
</style>